<div class="admin-password-reset-container" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<div class="tab selected">{{ labels.lbl_reset_de_senha }}</div>
	</div>

	<div class="body-wrap">
		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_email }} *</span>
			<input [value]="userEmail" (input)="userEmail = $event.target.value" />
		</div>

		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_senha }} *</span>
			<input [value]="newPassword" />
		</div>

		<div class="button-container">
			<div class="button" (click)="newPassword = this.generateNewRandomPassword(12)">{{ labels.lbl_gerar_nova_senha }}</div>
			<div
				class="button"
				(click)="resetPasswordButton.classList.contains('confirmClick') ? submitNewPassword() : confirmButton(resetPasswordButton)"
				#resetPasswordButton>
				{{ labels.lbl_geral_atualizar }}
			</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
